import _ from "lodash";

function baseDecimalRegex(digits, decimalPlaces, allowNegativeNumbers = false, allowZero = true) {
   let baseRegex = "";
   digits = _.toString(digits);
   decimalPlaces = _.toString(decimalPlaces);
   if (allowNegativeNumbers) {
      //^(-?(?=.*[1-9].*$)\d{0,5}(?:\.\d{0,2}))?$
      baseRegex = "^(-?(?=.*[1-9].*$)\\d{0," + digits + "}(?:\\.\\d{0," + decimalPlaces + "}))?$";
   } else {
      //^(?=.*[1-9].*$)\d{0,5}(?:\.\d{0,2})?$
      baseRegex = "^(?=.*[1-9].*$)\\d{0," + digits + "}(?:\\.\\d{0," + decimalPlaces + "})?$";
   }

   if (allowZero) {
      //^(([0]{1})(?:\.[0]{0,2})?)$|^(-?(?=.*[1-9].*$)\d{0,5}(?:\.\d{0,2}))?$  [includes negative]    OR
      //^(([0]{1})(?:\.[0]{0,2})?)$|^(?=.*[1-9].*$)\d{0,5}(?:\.\d{0,2})?$      [excludes negative]
      baseRegex = "^(([0]{1})(?:\\.[0]{0," + decimalPlaces + "})?)$|" + baseRegex;
   }
   return new RegExp(baseRegex);
}

function baseDecimalRegexWithCommas(value, digits, decimalPlaces, allowNegativeNumbers = false, allowZero = true) {
   let basicRegex = baseDecimalRegex(digits, decimalPlaces, allowNegativeNumbers, allowZero);
   digits = _.toString(digits);
   decimalPlaces = _.toString(decimalPlaces);
   // Commas are only needed on digits of 4 or more
   if (digits < 4) return basicRegex;

   // Based on the number of digits allowed, find out how many digits should be before the first comma (if any exist)
   let leadDigits = digits % 3;
   if (leadDigits === 0) leadDigits = 3;

   // Get the comma allowed expression to add to end
   let commaRegex = "";
   commaRegex = allowNegativeNumbers
      ? "^-?\\d{1," + leadDigits + "}(,\\d{3})*(?:\\.\\d{0," + decimalPlaces + "})?$" // ^-?\d{1,2}(,\d{3})*(?:\.\d{0,2})?$
      : "^\\d{1," + leadDigits + "}(,\\d{3})*(?:\\.\\d{0," + decimalPlaces + "})?$"; // ^\d{1,2}(,\d{3})*(?:\.\d{0,2})?$

   commaRegex = allowZero
      ? "(" + commaRegex + ")" // (^-?\d{1,2}(,\d{3})*(?:\.\d{0,2})?$)  [includes negative]  OR  (^\d{1,2}(,\d{3})*(?:\.\d{0,2})?$)     [excludes negative]
      : "((?!^0*$)" + commaRegex + ")"; // ((?!^0*$)^-?\d{1,2}(,\d{3})*(?:\.\d{0,2})?$)  [includes negative]  OR  ((?!^0*$)^\d{1,2}(,\d{3})*(?:\.\d{0,2})?$)     [excludes negative]

   //((?!^0*$)^\d{1,5}(?:\.\d{0,2})?$)|((?!^0*$)^\d{1,2}(,\d{3})*(?:\.\d{0,2})?$)
   //((?!^0*$)^-?\d{1,5}(?:\.\d{0,2})?$)|((?!^0*$)^-?\d{1,2}(,\d{3})*(?:\.\d{0,2})?$)
   let fullRegex = basicRegex + "|" + commaRegex;
   return new RegExp(fullRegex);
}

function IntegerRegex(digits, allowZero = true, allowNegativeNumbers = false) {
   digits = _.toString(digits);
   let baseRegex = "";
   baseRegex = allowNegativeNumbers
      ? "^-?\\d{1," + digits + "}$" //^-?\d{1,5}$
      : "^\\d{1," + digits + "}$"; //^\d{1,5}$

   if (!allowZero) {
      //(?!^0*$)^-?\d{1,5}$  [includes negative]    OR
      //(?!^0*$)^\d{1,5}$    [excludes negative]
      baseRegex = "(?!^0*$)" + baseRegex;
   }
   return new RegExp(baseRegex);
}

function IntegerRegexCommasAllowed(digits, allowZero = true, allowNegativeNumbers = false) {
   digits = _.toString(digits);
   let basicRegex = IntegerRegex(digits, allowZero, allowNegativeNumbers);

   // Commas are only needed on digits of 4 or more
   if (digits < 4) return basicRegex;

   // Based on the number of digits allowed, find out how many digits should be before the first comma
   let leadDigits = digits % 3;
   if (leadDigits === 0) leadDigits = 3;

   // Get the comma allowed expression to add to end
   let commaRegex = "";
   commaRegex = allowNegativeNumbers
      ? "^-?\\d{1," + digits + "}(,\\d{3})*" //^-?\d{1,2}(,\d{3})*
      : "^\\d{1," + digits + "}(,\\d{3})*"; //^\d{1,2}(,\d{3})*

   if (!allowZero) {
      //(?!^0*$)^-?\d{1,2}(,\d{3})*  [includes negative]    OR
      //(?!^0*$)^\d{1,2}(,\d{3})*    [excludes negative]
      commaRegex = "(?!^0*$)" + commaRegex;
   }

   //(^\d{1,5}$)|(^\d{1,2}(,\d{3})*$)
   //(^(?!^0*$)\d{1,5}$)|(^(?!^0*$)\d{1,2}(,\d{3})*$)
   let fullRegex = "(" + basicRegex + ")|(" + commaRegex + "$)";
   return new RegExp(fullRegex);
}

const rgx = {
   validateDecimal(value, field, digits, decimalPlaces, allowNegativeNumbers = false, allowZero = true) {
      let baseRegex = baseDecimalRegex(digits, decimalPlaces, allowNegativeNumbers, allowZero);
      let valid = baseRegex.test(value);
      // if (!valid) {
      //   console.log(`validateDecimal ${field}`, valid);
      // }
      return valid;
   },

   validateDecimalRange(value, field, digits, decimalPlaces, min, max, allowNegativeNumbers = false, allowZero = true) {
      value = parseFloat(value).toFixed(decimalPlaces);
      let baseRegex = baseDecimalRegex(digits, decimalPlaces, allowNegativeNumbers, allowZero);
      let valid = baseRegex.test(value);
      valid = valid && value >= min && value <= max;
      // if (!valid) {
      //   console.log(`validateDecimalRange ${field}`, valid);
      // }
      return valid;
   },

   validateDecimalRangeIncremental(value, field, digits, decimalPlaces, min, max, increment, allowNegativeNumbers = false, allowZero = true) {
      value = parseFloat(value).toFixed(decimalPlaces);
      let isGood = (value % increment === 0);
      let baseRegex = baseDecimalRegex(digits, decimalPlaces, allowNegativeNumbers, allowZero);
      let valid = baseRegex.test(value);
      valid = valid && isGood && value >= min && value <= max;
      return valid;
   },

   validateDecimalWithCommas(value, field, digits, decimalPlaces, allowNegativeNumbers = false, allowZero = true) {
      let baseRegex = baseDecimalRegexWithCommas(digits, decimalPlaces, allowNegativeNumbers, allowZero);
      let valid = baseRegex.test(value);
      // if (!valid) {
      //   console.log(`validateDecimalWithCommas ${field}`, valid);
      // }
      return valid;
   },

   validateHMS(value, field) {
      let baseRegex = /^([0-9]?[0-9]):([0-5][0-9]):([0-5][0-9])$/;
      let valid = baseRegex.test(value);
      // if (!valid) {
      //   console.log(`validateHMS ${field}`, valid);
      // }
      return valid;
   },

   validateInteger(value, field, digits, allowNegativeNumbers = false, allowZero = true) {
      let baseRegex = IntegerRegex(digits, allowNegativeNumbers, allowZero);
      let valid = baseRegex.test(value);
      // if (!valid) {
      //   console.log(`validateInteger ${field}`, valid);
      // }
      return valid;
   },

   validateIntegerRange(value, field, min, max, allowNegativeNumbers = false) {
      let baseRegex = IntegerRegexCommasAllowed(
         _.toString(max).length,
         min === 0,
         allowNegativeNumbers
      );
      let valid = baseRegex.test(value)
      value = parseInt(_.replace(value, /,/g, ""), 10);
      valid = valid && value >= min && value <= max;
      // if (!valid) {
      //   console.log(`validateIntegerRange ${field}`, valid);
      // }
      return valid;
   },

   validateIntegerWithCommas(value, field, digits, allowNegativeNumbers = false, allowZero = true) {
      let baseRegex = IntegerRegexCommasAllowed(digits, allowNegativeNumbers, allowZero);
      let valid = baseRegex.test(value);
      // if (!valid) {
      //   console.log(`validateIntegerWithCommas ${field}`, valid, value, baseRegex);
      // }
      return valid;
   },

};

export default rgx;
